
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150.25 150.25"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"75.12","cy":"75.12","r":"75.12","fill":"#3b7cf7"}}),_c('path',{attrs:{"d":"M27.12,46.35a5,5,0,0,0-5,5V106.8a5,5,0,0,0,5,5h94a5,5,0,0,0,5-5V51.38a5,5,0,0,0-5-5m0,0","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('path',{attrs:{"d":"M119.52,97.36v5a1.68,1.68,0,0,1-1.68,1.68H30.52a1.68,1.68,0,0,1-1.68-1.68v-5m90.68,0","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('path',{attrs:{"d":"M29.2,100.72c13.8-5.7,31.4-5.35,45,1V41.31a53.26,53.26,0,0,0-44.34-.46,1.7,1.7,0,0,0-1,1.55V87.05m.36,13.67","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('path',{attrs:{"d":"M109.19,37.69a53.23,53.23,0,0,0-35,3.62v60.45a55.62,55.62,0,0,1,44-1c1.12.46,1.36-.32,1.36-1.53V42.4M74.18,101.76","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])
          )
        }
      }
    